import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export interface CustomContentItemParams {
  id: number;
  position: number;
}

export class CustomContentItemEntity extends BaseEntityClass {
  id: number;
  position: number;

  constructor(params: CustomContentItemParams) {
    super();
    this.id = params.id;
    this.position = params.position;
  }
}
